import React from "react";

const reasons = [
  {
    icon: "rocket_launch",
    title: "Fast Project Delivery",
    desc: "Rapid development with agile sprints, weekly demos, and transparent communication to launch your product faster.",
  },
  {
    icon: "deployed_code",
    title: "Modern Technology Stack",
    desc: "Built using React, Next.js, Java, Spring Boot, Node.js, cloud infrastructure, and scalable microservice architecture.",
  },
  {
    icon: "workspace_premium",
    title: "Enterprise Quality",
    desc: "Every project undergoes code reviews, automated testing, security checks, and performance optimization.",
  },
  {
    icon: "account_tree",
    title: "Scalable Architecture",
    desc: "Our solutions are designed to grow with your business while remaining secure, maintainable, and high-performing.",
  },
  {
    icon: "support_agent",
    title: "Long-Term Partnership",
    desc: "Beyond launch, we provide continuous maintenance, feature upgrades, monitoring, and dedicated technical support.",
  },
  {
    icon: "trending_up",
    title: "Business-Driven Results",
    desc: "We focus on solving business problems and building digital products that improve efficiency, engagement, and revenue.",
  },
];

export default function WhyChooseUs() {
  return (
    <section
      className="
        w-full
        overflow-hidden
        bg-[#F7F4EE]
        py-12
        sm:py-16
        lg:py-20
      "
    >
      <div
        className="
          mx-auto
          w-full
          max-w-7xl
          px-4
          sm:px-6
          lg:px-8
        "
      >
        {/* Heading */}
        <div
          className="
            mx-auto
            mb-8
            max-w-3xl
            text-center
            sm:mb-12
            lg:mb-16
          "
        >
          <p
            className="
              mb-2
              text-[10px]
              font-semibold
              uppercase
              tracking-[0.2em]
              text-[#C8762A]
              sm:mb-3
              sm:text-xs
            "
          >
            Why Choose Us
          </p>

          <h2
            className="
              text-[28px]
              font-bold
              leading-[1.15]
              text-[#1A1714]
              sm:text-4xl
              lg:text-5xl
            "
          >
            Built For
            <br />

            <span className="text-[#C8762A]">
              Long-Term Success
            </span>
          </h2>

          <p
            className="
              mx-auto
              mt-4
              max-w-[350px]
              text-sm
              leading-6
              text-stone-600
              sm:max-w-2xl
              sm:text-base
              sm:leading-7
            "
          >
            We combine design excellence, engineering expertise, and business
            strategy to build digital products that scale.
          </p>
        </div>

        {/* Cards Grid */}
        <div
          className="
            grid
            grid-cols-2
            gap-3
            sm:gap-4
            md:gap-5
            lg:grid-cols-3
            lg:gap-6
          "
        >
          {reasons.map((item) => (
            <div
              key={item.title}
              className="
                group
                relative
                min-w-0
                overflow-hidden
                rounded-xl
                border
                border-stone-200
                bg-white
                p-3
                shadow-sm
                transition-all
                duration-300

                sm:rounded-2xl
                sm:p-5

                md:p-6

                lg:hover:-translate-y-2
                lg:hover:border-[#C8762A]
                lg:hover:shadow-xl
              "
            >
              {/* Decorative Circle */}
              <div
                className="
                  pointer-events-none
                  absolute
                  -right-8
                  -top-8
                  h-16
                  w-16
                  rounded-full
                  bg-[#FBF0E2]
                  transition-transform
                  duration-500

                  sm:-right-10
                  sm:-top-10
                  sm:h-24
                  sm:w-24

                  lg:group-hover:scale-125
                "
              />

              {/* Icon */}
              <div
                className="
                  relative
                  mb-3
                  flex
                  h-10
                  w-10
                  items-center
                  justify-center
                  rounded-xl
                  shadow-sm

                  sm:mb-4
                  sm:h-12
                  sm:w-12
                  sm:rounded-2xl
                  sm:shadow-md

                  md:h-14
                  md:w-14
                "
                style={{
                  background:
                    "linear-gradient(135deg, #C8762A 0%, #E9A14E 100%)",
                }}
              >
                <span
                  className="
                    material-symbols-outlined
                    text-xl
                    text-white

                    sm:text-2xl

                    md:text-3xl
                  "
                >
                  {item.icon}
                </span>
              </div>

              {/* Title */}
              <h3
                className="
                  relative
                  mb-1.5
                  break-words
                  text-sm
                  font-bold
                  leading-[1.3]
                  text-[#1A1714]

                  sm:mb-2
                  sm:text-base

                  md:text-xl
                "
              >
                {item.title}
              </h3>

              {/* Description */}
              <p
                className="
                  relative
                  break-words
                  text-[11px]
                  leading-[1.55]
                  text-stone-600

                  sm:text-xs
                  sm:leading-5

                  md:text-sm
                  md:leading-7
                "
              >
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}